
































import { Vue, Component } from 'vue-property-decorator';
import DashboardServices from '@/services/dashboard';
import { getRange } from '@/libs/time';
import LabelTag from './LabelTag.vue';
@Component({
  components: { LabelTag }
})
export default class CenterCmp extends Vue {
  dashSrv = new DashboardServices();

  config: any = {
    data: [],
    color: ['#d50000', '#fc7c0d', '#ffea00'],
    lineWidth: 30,
    radius: '55%',
    activeRadius: '60%'
  };

  labelConfig = {
    data: ['红色警告（一级预警）', '橙色警示（二级预警）', '黄色提醒（三级预警）']
  };

  total: number = 0;

  created() {
    let [startTime, endTime] = getRange('total');
    this.getAllAlert({ startTime, endTime });
  }

  get TOTAL() {
    return (this.total + '').padStart(6, '0').split('');
  }

  async getAllAlert(params?: any) {
    let res = await this.dashSrv.getAllAlert(params);
    this.total = res.allCount.total;
    this.config.data = [
      {
        name: '一级预警',
        value: res.allCount.oneLevelTotal,
        percent: ((res.allCount.oneLevelTotal / this.total) * 100).toFixed(1)
      },
      {
        name: '二级预警',
        value: res.allCount.twoLevelTotal,
        percent: ((res.allCount.twoLevelTotal / this.total) * 100).toFixed(1)
      },
      {
        name: '三级预警',
        value: res.allCount.threeLevelTotal,
        percent: ((res.allCount.threeLevelTotal / this.total) * 100).toFixed(1)
      }
    ];
  }
}
